// @flow
import React, { Component } from 'react';
import { Field } from 'redux-form';
import {
  BeneficiaryInformationDiv,
  TitleH3,
  SectionWrapperDiv,
  Section,
  BankAccountInput
} from './BankAccountStyles';
import { requiredField } from '../../../utilities/validations';

type Props = { editable: boolean };

export default class BeneficiaryInformation extends Component<Props> {
  render() {
    return (
      <BeneficiaryInformationDiv>
        <TitleH3>Beneficiary Information</TitleH3>
        <SectionWrapperDiv>
          <Section>
            <Field
              name="beneficiary_name"
              label="Full Name"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="beneficiary_address"
              label="Address"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="beneficiary_zip"
              label="Zip/Postal Code"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
          </Section>
          <Section right>
            <Field
              name="beneficiary_state"
              label="State / Province"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
            <Field
              name="beneficiary_country"
              label="Country"
              component={BankAccountInput}
              readOnly={this.props.editable}
              validate={requiredField}
            />
          </Section>
        </SectionWrapperDiv>
      </BeneficiaryInformationDiv>
    );
  }
}
